export const productsData = [
  {
    id: 1,
    slug: 'intelligent-fire-alarm-control-panel',
    name: 'Intelligent Fire Alarm Control Panel',
    category: 'alarms',
    shortDescription: 'Advanced addressable fire alarm system with LCD display and network connectivity for large buildings.',
    description: 'Advanced addressable fire alarm system with LCD display and network connectivity designed for comprehensive fire detection in large commercial and industrial buildings.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20professional%20QCDD%20approved%20fire%20detection%20system%20with%20clean%20technical%20background%20and%20network%20connectivity%20features&width=400&height=300&seq=alarm-panel&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Modern%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20professional%20QCDD%20approved%20fire%20detection%20system%20with%20clean%20technical%20background%20and%20network%20connectivity%20features&width=600&height=400&seq=alarm-panel-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Fire%20alarm%20control%20panel%20LCD%20display%20showing%20system%20status%20and%20zone%20information%2C%20professional%20addressable%20fire%20detection%20interface%20with%20network%20connectivity%20and%20QCDD%20certification&width=600&height=400&seq=alarm-panel-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Fire%20alarm%20control%20panel%20installation%20in%20electrical%20room%20with%20network%20cables%20and%20power%20connections%2C%20professional%20fire%20safety%20system%20setup%20with%20QCDD%20approval&width=600&height=400&seq=alarm-panel-3&orientation=landscape'
    ],
    compliance: 'QCDD Approved',
    features: [
      'LCD display with zone indication',
      'Network connectivity for remote monitoring',
      'Addressable device support up to 250 points',
      'Built-in event logging and reporting',
      'Battery backup with auto-charging',
      'Multi-language support'
    ],
    specifications: {
      'Operating Voltage': '220-240V AC',
      'Battery Backup': '24V 7Ah',
      'Zone Capacity': 'Up to 250 addressable points',
      'Display': '4-line LCD with backlight',
      'Communication': 'RS485, Ethernet',
      'Certification': 'QCDD, EN54'
    },
    certifications: ['QCDD', 'EN54', 'ISO 9001'],
    datasheet_url: '#',
    meta_title: 'Intelligent Fire Alarm Control Panel | FlameGuardQA',
    meta_description: 'Advanced addressable fire alarm control panel with LCD display and network connectivity for comprehensive fire detection.'
  },
  {
    id: 2,
    slug: 'smoke-heat-detectors',
    name: 'Smoke & Heat Detectors (EN54 Certified)',
    category: 'alarms',
    shortDescription: 'High-sensitivity optical smoke detectors and thermal heat detectors for comprehensive fire detection.',
    description: 'High-sensitivity optical smoke detectors and thermal heat detectors designed for early and reliable fire detection in all environments.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20smoke%20and%20heat%20detectors%20mounted%20on%20white%20ceiling%2C%20QCDD%20approved%20fire%20detection%20sensors%20with%20red%20LED%20indicators%20and%20clean%20technical%20installation%20in%20Qatar%20commercial%20building&width=400&height=300&seq=detectors&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20smoke%20and%20heat%20detectors%20mounted%20on%20white%20ceiling%2C%20QCDD%20approved%20fire%20detection%20sensors%20with%20red%20LED%20indicators%20and%20clean%20technical%20installation%20in%20Qatar%20commercial%20building&width=600&height=400&seq=detectors-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Close-up%20view%20of%20optical%20smoke%20detector%20with%20LED%20alarm%20indicator%20and%20EN54%20certification%20marking%2C%20professional%20fire%20detection%20sensor%20with%20clean%20white%20background&width=600&height=400&seq=detectors-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Heat%20detector%20installation%20in%20industrial%20environment%20with%20high%20temperature%20rating%2C%20professional%20thermal%20fire%20detection%20sensor%20with%20QCDD%20approval&width=600&height=400&seq=detectors-3&orientation=landscape'
    ],
    compliance: 'EN54 Certified',
    features: [
      'Optical smoke & heat sensors',
      'Low-profile design for easy installation',
      'Auto-reset after alarm',
      'LED alarm indicator',
      'Compatible with addressable and conventional panels'
    ],
    specifications: {
      'Operating Voltage': '12–24V DC',
      'Operating Temperature': '-10°C to 50°C',
      'Alarm Indicator': 'LED (Red)',
      'Certification': 'EN54, QCDD',
      'Detection Method': 'Optical smoke / Thermal heat',
      'Response Time': '< 30 seconds'
    },
    certifications: ['EN54', 'QCDD', 'CE'],
    datasheet_url: '#',
    meta_title: 'Smoke & Heat Detectors | FlameGuardQA',
    meta_description: 'High-sensitivity EN54-certified smoke and heat detectors for reliable fire detection.'
  },
  {
    id: 3,
    slug: 'manual-call-points',
    name: 'Manual Call Points (IP65 Rated)',
    category: 'alarms',
    shortDescription: 'Break-glass manual fire alarm activation points with protective covers and reset keys.',
    description: 'Durable break-glass or resettable manual fire alarm points designed for indoor and outdoor environments.',
    image: 'https://readdy.ai/api/search-image?query=Red%20break%20glass%20manual%20fire%20alarm%20call%20point%20mounted%20on%20white%20wall%2C%20professional%20fire%20safety%20activation%20device%20with%20protective%20cover%20and%20QCDD%20approval%20marking%20in%20Qatar%20building&width=400&height=300&seq=call-points&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Red%20break%20glass%20manual%20fire%20alarm%20call%20point%20mounted%20on%20white%20wall%2C%20professional%20fire%20safety%20activation%20device%20with%20protective%20cover%20and%20QCDD%20approval%20marking%20in%20Qatar%20building&width=600&height=400&seq=call-points-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Manual%20call%20point%20with%20transparent%20protective%20cover%20and%20test%20key%2C%20professional%20fire%20alarm%20activation%20device%20with%20IP65%20weatherproof%20rating&width=600&height=400&seq=call-points-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Outdoor%20manual%20call%20point%20installation%20with%20IP65%20weatherproof%20protection%2C%20professional%20fire%20alarm%20device%20for%20harsh%20environments%20with%20QCDD%20certification&width=600&height=400&seq=call-points-3&orientation=landscape'
    ],
    compliance: 'IP65 Rated',
    features: [
      'IP65 weatherproof design',
      'Break-glass or resettable option',
      'Protective transparent cover',
      'Test key included',
      'Compatible with all fire alarm systems'
    ],
    specifications: {
      'Material': 'Polycarbonate',
      'Mounting': 'Surface / Flush',
      'Protection': 'IP65',
      'Certification': 'QCDD, EN54',
      'Operating Temperature': '-20°C to 60°C',
      'Contact Rating': '1A at 30V DC'
    },
    certifications: ['QCDD', 'EN54', 'IP65'],
    datasheet_url: '#',
    meta_title: 'Manual Call Points | FlameGuardQA',
    meta_description: 'IP65-rated manual call points with break-glass design for reliable manual alarm activation.'
  },
  {
    id: 4,
    slug: 'co2-extinguishers',
    name: 'CO₂ Fire Extinguishers (QCDD Approved)',
    category: 'extinguishers',
    shortDescription: 'Clean agent CO₂ extinguishers ideal for electrical fires and sensitive equipment protection.',
    description: 'Clean agent CO₂ extinguishers ideal for electrical and electronic equipment protection, leaving no residue after discharge.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20red%20CO2%20fire%20extinguisher%20with%20black%20horn%20and%20pressure%20gauge%2C%20QCDD%20approved%20clean%20agent%20fire%20suppression%20equipment%20for%20electrical%20fires%20with%20technical%20specifications%20label&width=400&height=300&seq=co2-extinguisher&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20red%20CO2%20fire%20extinguisher%20with%20black%20horn%20and%20pressure%20gauge%2C%20QCDD%20approved%20clean%20agent%20fire%20suppression%20equipment%20for%20electrical%20fires%20with%20technical%20specifications%20label&width=600&height=400&seq=co2-extinguisher-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=CO2%20fire%20extinguisher%20discharge%20horn%20and%20safety%20mechanism%2C%20professional%20clean%20agent%20fire%20suppression%20equipment%20with%20QCDD%20certification%20for%20electrical%20protection&width=600&height=400&seq=co2-extinguisher-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Multiple%20CO2%20fire%20extinguishers%20in%20different%20sizes%202kg%205kg%209kg%2C%20professional%20clean%20agent%20fire%20suppression%20equipment%20lineup%20with%20QCDD%20approval&width=600&height=400&seq=co2-extinguisher-3&orientation=landscape'
    ],
    compliance: 'QCDD Approved',
    features: [
      'Non-conductive extinguishing agent',
      'Safe for use on electrical fires',
      'Lightweight aluminum cylinder',
      'Easy to operate, low maintenance'
    ],
    specifications: {
      'Capacity': '2kg / 5kg / 9kg',
      'Working Pressure': '55 bar',
      'Discharge Time': '12–18 seconds',
      'Certification': 'QCDD, ISO',
      'Agent Type': 'Carbon Dioxide',
      'Fire Classes': 'B, C (Electrical)'
    },
    certifications: ['QCDD', 'ISO', 'CE'],
    datasheet_url: '#',
    meta_title: 'CO₂ Fire Extinguishers | FlameGuardQA',
    meta_description: 'QCDD-approved CO₂ fire extinguishers for electrical and sensitive equipment protection.'
  },
  {
    id: 5,
    slug: 'dry-chemical-extinguishers',
    name: 'Dry Chemical Extinguishers (ABC Class)',
    category: 'extinguishers',
    shortDescription: 'Multi-purpose ABC dry chemical extinguishers for Class A, B, and C fires in commercial settings.',
    description: 'Multi-purpose ABC dry chemical extinguishers suitable for Class A (solid), Class B (liquid), and Class C (gas) fires.',
    image: 'https://readdy.ai/api/search-image?query=Red%20ABC%20dry%20chemical%20fire%20extinguisher%20with%20pressure%20gauge%20and%20safety%20pin%2C%20professional%20multi-purpose%20fire%20suppression%20equipment%20with%20QCDD%20certification%20marking%20and%20technical%20specifications&width=400&height=300&seq=dry-chemical&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Red%20ABC%20dry%20chemical%20fire%20extinguisher%20with%20pressure%20gauge%20and%20safety%20pin%2C%20professional%20multi-purpose%20fire%20suppression%20equipment%20with%20QCDD%20certification%20marking%20and%20technical%20specifications&width=600&height=400&seq=dry-chemical-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=ABC%20dry%20chemical%20extinguisher%20discharge%20nozzle%20and%20hose%20assembly%2C%20professional%20multi-purpose%20fire%20suppression%20equipment%20with%20QCDD%20approval&width=600&height=400&seq=dry-chemical-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Multiple%20ABC%20dry%20chemical%20extinguishers%20in%20different%20capacities%206kg%209kg%2012kg%2C%20professional%20fire%20suppression%20equipment%20lineup%20with%20QCDD%20certification&width=600&height=400&seq=dry-chemical-3&orientation=landscape'
    ],
    compliance: 'ABC Class Rated',
    features: [
      'Effective on A, B, and C class fires',
      'Corrosion-resistant cylinder',
      'High discharge range',
      'Easy recharge and servicing'
    ],
    specifications: {
      'Capacity': '6kg / 9kg / 12kg',
      'Propellant': 'Nitrogen',
      'Working Pressure': '15 bar',
      'Certification': 'QCDD, ISO',
      'Agent Type': 'Monoammonium Phosphate',
      'Fire Classes': 'A, B, C'
    },
    certifications: ['QCDD', 'ISO', 'CE'],
    datasheet_url: '#',
    meta_title: 'ABC Dry Chemical Fire Extinguishers | FlameGuardQA',
    meta_description: 'Multi-purpose ABC dry chemical extinguishers for versatile fire protection.'
  },
  {
    id: 6,
    slug: 'foam-extinguishers',
    name: 'Foam Fire Extinguishers (AFFF)',
    category: 'extinguishers',
    shortDescription: 'AFFF foam extinguishers designed for Class A and B fires, particularly effective on liquid fires.',
    description: 'AFFF foam extinguishers designed for Class A and B fires, especially effective on flammable liquid fires.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20foam%20fire%20extinguisher%20with%20cream%20colored%20body%20and%20red%20components%2C%20AFFF%20fire%20suppression%20equipment%20for%20liquid%20fires%20with%20QCDD%20approval%20and%20technical%20specifications%20label&width=400&height=300&seq=foam-extinguisher&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20foam%20fire%20extinguisher%20with%20cream%20colored%20body%20and%20red%20components%2C%20AFFF%20fire%20suppression%20equipment%20for%20liquid%20fires%20with%20QCDD%20approval%20and%20technical%20specifications%20label&width=600&height=400&seq=foam-extinguisher-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=AFFF%20foam%20extinguisher%20discharge%20nozzle%20creating%20foam%20spray%20pattern%2C%20professional%20fire%20suppression%20equipment%20for%20liquid%20fires%20with%20QCDD%20certification&width=600&height=400&seq=foam-extinguisher-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Foam%20fire%20extinguisher%20trolley%20unit%2050L%20capacity%20with%20wheels%20and%20hose%20assembly%2C%20professional%20AFFF%20fire%20suppression%20equipment%20with%20QCDD%20approval&width=600&height=400&seq=foam-extinguisher-3&orientation=landscape'
    ],
    compliance: 'AFFF Formula',
    features: [
      'AFFF foam formula for liquid fires',
      'Quick knock-down effect',
      'Corrosion-resistant body',
      'Safe and eco-friendly agent'
    ],
    specifications: {
      'Capacity': '9L / 50L trolley',
      'Pressure': '12 bar',
      'Discharge Range': '4–6m',
      'Certification': 'QCDD, EN3',
      'Agent Type': 'AFFF Foam',
      'Fire Classes': 'A, B'
    },
    certifications: ['QCDD', 'EN3', 'CE'],
    datasheet_url: '#',
    meta_title: 'Foam Fire Extinguishers | FlameGuardQA',
    meta_description: 'AFFF foam extinguishers for fast control of Class A and B fires — QCDD approved.'
  },
  {
    id: 7,
    slug: 'sprinkler-systems',
    name: 'Sprinkler Heads & Systems (UL Listed)',
    category: 'sprinklers',
    shortDescription: 'High-performance sprinkler heads with various temperature ratings and spray patterns for optimal coverage.',
    description: 'High-performance sprinkler heads with varied temperature ratings and spray patterns for maximum coverage.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20heads%20installed%20in%20ceiling%20with%20red%20pipes%20and%20brass%20fittings%2C%20QCDD%20approved%20sprinkler%20system%20with%20various%20temperature%20ratings%20and%20spray%20patterns%20in%20Qatar%20commercial%20building&width=400&height=300&seq=sprinkler-heads&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20heads%20installed%20in%20ceiling%20with%20red%20pipes%20and%20brass%20fittings%2C%20QCDD%20approved%20sprinkler%20system%20with%20various%20temperature%20ratings%20and%20spray%20patterns%20in%20Qatar%20commercial%20building&width=600&height=400&seq=sprinkler-heads-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Close-up%20view%20of%20brass%20fire%20sprinkler%20head%20with%20temperature%20rating%20bulb%2C%20professional%20UL%20listed%20sprinkler%20system%20component%20with%20technical%20specifications&width=600&height=400&seq=sprinkler-heads-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Various%20types%20of%20fire%20sprinkler%20heads%20upright%20pendant%20and%20concealed%20models%2C%20professional%20UL%20listed%20sprinkler%20system%20components%20with%20different%20finishes&width=600&height=400&seq=sprinkler-heads-3&orientation=landscape'
    ],
    compliance: 'UL Listed',
    features: [
      'Upright, pendant, and concealed types',
      'Quick response and standard response models',
      'Brass, chrome, or white finishes',
      'UL and FM approved'
    ],
    specifications: {
      'K-Factors': '5.6 / 8.0 / 11.2',
      'Temperature Ratings': '57°C–93°C',
      'Certification': 'UL, FM, QCDD',
      'Material': 'Brass',
      'Thread': '1/2" NPT',
      'Response': 'Quick / Standard'
    },
    certifications: ['UL', 'FM', 'QCDD'],
    datasheet_url: '#',
    meta_title: 'Sprinkler Heads & Systems | FlameGuardQA',
    meta_description: 'UL-listed sprinkler systems for reliable automatic fire suppression.'
  },
  {
    id: 8,
    slug: 'fire-pump-sets',
    name: 'Fire Pump Sets (NFPA 20 Standard)',
    category: 'sprinklers',
    shortDescription: 'Electric and diesel-driven fire pump systems with jockey pumps for maintaining system pressure.',
    description: 'Electric and diesel-driven fire pump systems designed per NFPA 20 for consistent pressure in sprinkler and hydrant networks.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20fire%20pump%20system%20with%20electric%20motor%20and%20control%20panel%2C%20professional%20fire%20suppression%20pump%20equipment%20with%20pressure%20gauges%20and%20QCDD%20certification%20in%20Qatar%20fire%20station&width=400&height=300&seq=fire-pumps&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Industrial%20fire%20pump%20system%20with%20electric%20motor%20and%20control%20panel%2C%20professional%20fire%20suppression%20pump%20equipment%20with%20pressure%20gauges%20and%20QCDD%20certification%20in%20Qatar%20fire%20station&width=600&height=400&seq=fire-pumps-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Diesel%20fire%20pump%20engine%20with%20control%20panel%20and%20automatic%20start%20system%2C%20professional%20NFPA%2020%20compliant%20fire%20suppression%20equipment%20with%20QCDD%20approval&width=600&height=400&seq=fire-pumps-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Fire%20pump%20control%20panel%20with%20pressure%20gauges%20and%20automatic%20start%20controls%2C%20professional%20NFPA%2020%20fire%20suppression%20system%20monitoring%20equipment&width=600&height=400&seq=fire-pumps-3&orientation=landscape'
    ],
    compliance: 'NFPA 20 Standard',
    features: [
      'Electric or diesel-driven main pump',
      'Jockey pump for pressure maintenance',
      'Automatic start control panel',
      'Skid-mounted or packaged units'
    ],
    specifications: {
      'Flow': 'Custom (as per project)',
      'Head': '40–120m',
      'Motor': '10HP–150HP',
      'Certification': 'QCDD, NFPA 20',
      'Control': 'Automatic start/stop',
      'Mounting': 'Skid-mounted'
    },
    certifications: ['QCDD', 'NFPA 20', 'UL'],
    datasheet_url: '#',
    meta_title: 'Fire Pump Sets | FlameGuardQA',
    meta_description: 'NFPA 20-compliant fire pump sets with electric/diesel options for reliable water supply.'
  },
  {
    id: 9,
    slug: 'control-valves',
    name: 'Control Valves & Accessories (FM Approved)',
    category: 'sprinklers',
    shortDescription: 'Butterfly valves, gate valves, and flow control devices for sprinkler system management.',
    description: 'Butterfly, gate, and flow control valves for efficient sprinkler and hydrant system management.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20control%20valves%20and%20butterfly%20valves%20with%20red%20handles%20and%20brass%20fittings%2C%20QCDD%20approved%20flow%20control%20devices%20for%20fire%20suppression%20systems%20with%20technical%20specifications&width=400&height=300&seq=control-valves&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20control%20valves%20and%20butterfly%20valves%20with%20red%20handles%20and%20brass%20fittings%2C%20QCDD%20approved%20flow%20control%20devices%20for%20fire%20suppression%20systems%20with%20technical%20specifications&width=600&height=400&seq=control-valves-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Gate%20valve%20and%20butterfly%20valve%20assembly%20for%20fire%20sprinkler%20system%20with%20tamper%20switch%2C%20professional%20FM%20approved%20flow%20control%20equipment%20with%20QCDD%20certification&width=600&height=400&seq=control-valves-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Fire%20sprinkler%20system%20valve%20room%20with%20multiple%20control%20valves%20and%20flow%20meters%2C%20professional%20fire%20suppression%20system%20management%20equipment%20with%20FM%20approval&width=600&height=400&seq=control-valves-3&orientation=landscape'
    ],
    compliance: 'FM Approved',
    features: [
      'FM and UL listed valves',
      'Corrosion-resistant body',
      'Tamper switch compatible',
      'Easy operation and maintenance'
    ],
    specifications: {
      'Sizes': '2" to 12"',
      'Material': 'Ductile iron / brass',
      'Rating': 'PN16 / PN25',
      'Certification': 'FM, UL, QCDD',
      'Operation': 'Manual / Electric',
      'Temperature': '-20°C to 120°C'
    },
    certifications: ['FM', 'UL', 'QCDD'],
    datasheet_url: '#',
    meta_title: 'Control Valves & Accessories | FlameGuardQA',
    meta_description: 'FM-approved control valves and accessories for efficient fire system management.'
  },
  {
    id: 10,
    slug: 'emergency-exit-signs',
    name: 'Emergency Exit Signs (Self-Testing)',
    category: 'lighting',
    shortDescription: 'LED illuminated exit signs with battery backup and self-testing capabilities for safe evacuation.',
    description: 'LED illuminated exit signs with battery backup and self-testing capabilities for safe evacuation.',
    image: 'https://readdy.ai/api/search-image?query=Green%20LED%20emergency%20exit%20sign%20with%20running%20man%20symbol%20and%20arrow%2C%20professional%20evacuation%20lighting%20with%20battery%20backup%20mounted%20on%20white%20wall%20in%20Qatar%20commercial%20building&width=400&height=300&seq=exit-signs&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Green%20LED%20emergency%20exit%20sign%20with%20running%20man%20symbol%20and%20arrow%2C%20professional%20evacuation%20lighting%20with%20battery%20backup%20mounted%20on%20white%20wall%20in%20Qatar%20commercial%20building&width=600&height=400&seq=exit-signs-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Emergency%20exit%20sign%20with%20self-testing%20LED%20indicators%20and%20battery%20backup%2C%20professional%20evacuation%20lighting%20system%20with%20automatic%20testing%20function&width=600&height=400&seq=exit-signs-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Multiple%20emergency%20exit%20signs%20in%20corridor%20showing%20different%20mounting%20options%2C%20professional%20evacuation%20lighting%20system%20with%20self-testing%20capabilities&width=600&height=400&seq=exit-signs-3&orientation=landscape'
    ],
    compliance: 'Self-Testing',
    features: [
      'LED illumination for energy efficiency',
      '3-hour battery backup',
      'Self-testing functionality',
      'Multiple mounting options',
      'Pictogram and text options'
    ],
    specifications: {
      'LED Life': '50,000 hours',
      'Battery Backup': '3 hours',
      'Viewing Distance': '30m',
      'Certification': 'QCDD, CE',
      'Operating Temperature': '-10°C to 40°C',
      'IP Rating': 'IP65'
    },
    certifications: ['QCDD', 'CE', 'IP65'],
    datasheet_url: '#',
    meta_title: 'Emergency Exit Signs | FlameGuardQA',
    meta_description: 'Self-testing LED emergency exit signs with 3-hour battery backup for reliable evacuation guidance.'
  }
];